module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-container"
  }, [(_vm.markers.length <= 0) ? [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Missing map markers")])] : [_c('ul', {
    staticClass: "map-menu"
  }, _vm._l((_vm.markers), function(marker, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < 6),
        expression: "index < 6"
      }],
      key: index,
      staticClass: "marker-info",
      class: {
        'active': marker.active
      },
      style: ('background-image: url(' + marker.logo + ')')
    }, [_c('a', {
      ref: "menuItem",
      refInFor: true,
      attrs: {
        "href": "#click"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleActive(marker, index)
        }
      }
    }, [_c('span', {
      staticClass: "marker-info-title",
      domProps: {
        "innerHTML": _vm._s(marker.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "marker-info-description",
      domProps: {
        "innerHTML": _vm._s(marker.description)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "marker-info-rating"
    }, [_c('star-rating', {
      attrs: {
        "rating": marker.rating,
        "active": marker.active
      }
    })], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "map"
  }, [_c('gmap-map', {
    ref: "map",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "options": _vm.options,
      "center": _vm.options.center
    }
  }, [(_vm.popupActive) ? _c('gmap-info-window', {
    attrs: {
      "options": _vm.popupOptions,
      "opened": true,
      "position": _vm.popupPosition,
      "content": _vm.popupContent
    },
    on: {
      "closeclick": function($event) {
        _vm.toggleActive(_vm.activeMarker, _vm.activeMarkerIndex)
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.markers), function(marker, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "icon": _vm.getMarkerIcon(marker, index),
        "clickable": _vm.markerOptions.clickable
      },
      on: {
        "mouseover": function($event) {
          _vm.toggleActive(marker, index)
        }
      }
    })
  })], 2)], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Eugen/.config/yarn/global/~/vue-loader/lib/template-compiler?{"id":"data-v-2c5d25b4"}!/Users/Eugen/.config/yarn/global/~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Map.vue
// module id = 208
// module chunks = 0